"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _expert = require("@/api/expert/expert");
var _index = _interopRequireDefault(require("@/components/wordDia/index.vue"));
var _public = require("@/api/public/public");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import ZhjySerach from "@/components/search/zhjySerach.vue";
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "200"
      }, {
        name: "所属项目类型",
        prop: "matchTypeName",
        isShow: true,
        width: "100"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      options: [{
        name: "进入",
        class: "editor",
        option: "entryList",
        span: 24
      }, {
        name: "下载承诺书",
        class: "editor",
        option: "guarantee",
        span: 24
      }],
      textInfo: {
        title: "专家承诺书",
        info: "专家承诺书",
        url: "bureau/import",
        code: "https://file.icve.com.cn/ssykt/424/314/6A34E97266089C3FBAB1D238387AC372.xlsx"
      },
      matchId: "",
      proFlag: 0
    };
  },
  methods: {
    // 判断专家是否提交过认证资料
    isAccept: function isAccept(id) {
      var _this = this;
      console.log(id);
      if (this.proFlag === 1) {
        (0, _expert.isChecked)({
          param: id
        }).then(function (res) {
          console.log(res);
          if (res.data == false) {
            return _this.$message.error("请先下载并提交专家承诺书后，再点击进入。");
          } else {
            _this.$router.push({
              path: "/grade/grade-list",
              query: {
                id: id
              }
            });
          }
        });
      } else {
        this.$router.push({
          path: "/grade/grade-list",
          query: {
            id: id
          }
        });
      }
    },
    // downExcel
    downExcel: function downExcel() {},
    // 下载专家承诺书
    guarantee: function guarantee(e) {
      this.matchId = e.id;
      if (e.agreement === null) {
        this.$message.error("当前项目,管理员暂未提交承诺书。");
      } else {
        this.textInfo.code = e.agreement;
        this.$refs.dialogVal.changShow();
      }
    },
    // 进入下级列表
    entryList: function entryList(e) {
      this.isAccept(e.id);
    },
    // 获取审核作品项目列表
    getAuditWorkList: function getAuditWorkList() {
      var _this2 = this;
      (0, _expert.getProject)({
        // name: this.queryValue,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        console.log(res, "项目列表");
        var data = res.data;
        _this2.listData = data.list;
        _this2.totalData = data.total;
      });
    },
    // 模糊搜索
    search: function search(e) {
      this.queryValue = e.queryValue;
      this.getMajorList();
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this3 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this3.checkBoxs.push(item.id);
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getMajorList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageNumber = 1;
      this.page.pageSize = e;
      this.getMajorList();
    },
    setFlag: function setFlag() {
      // webConfig({
      //   param: this.prCode
      // }).then(res => {
      //   const { data } = res;
      //   sessionStorage.setItem(
      //     "book",
      //     JSON.stringify(data.expertAuthentication)
      //   );
      // });
    }
  },
  created: function created() {
    this.proFlag = JSON.parse(sessionStorage.getItem("book")) || "";
    this.getAuditWorkList();
    // watch
    // if (this.proFlag == "") {
    //   this.setFlag();
    //   this.proFlag = JSON.parse(sessionStorage.getItem("book"));
    // } else
    if (this.proFlag == 0) {
      this.options = [{
        name: "进入",
        class: "editor",
        option: "entryList",
        span: 24
      }];
    }
  },
  components: {
    // ZhjySerach,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default,
    WordDia: _index.default
  }
};